import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  headerButtons: {
    display: 'flex',
    gap: '8px',
  },
  alert: {
    margin: '-16px 0 20px',
  },
  container: {
    display: 'flex',
    width: '100%',
    height: '100%',
    padding: '32px',
    flexDirection: 'column',
  },
  subcontainer: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 21px',
    marginBottom: '30px',
    flexDirection: 'column',
    border: '1px solid #E3E3E3',
    borderRadius: '8px',
  },
  wrapper: {
    display: 'flex',
    width: '100%',
    height: '85px',
    alignContent: 'center',
    alignItems: 'center',
    gap: '44px',
  },
  input: {
    width: '30%',
  },
  inputSize: {
    width: '100%',
  },
  inputLabel: {
    color: 'black',
    fontSize: '12px',
    fontWeight: '500',
    display: 'flex',
    gap: '4px',
  },
  asterisk: {
    color: 'red',
  },
  button: {
    height: '43px',
    width: '100px',
    padding: '10px 16px',
  },
  label: {
    top: '-8px',
    left: '15px',
    padding: '0px 6px',
    position: 'absolute',
    backgroundColor: 'white',
  },
  helperText: {
    width: '100%',
    marginTop: '8px',
  },
  paymentLinkContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: spacing(16),
    padding: `${spacing(8)} 0`,
  },
  paymentLinkInfo: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    margin: 0,
    padding: 0,
    listStyle: 'none',
    gap: spacing(8),
  },
  paymentLinkInfoTitle: {
    fontWeight: 500,
    color: Theme.Colors.Grayscale.Eighty,
  },
  paymentLinkItem: {
    display: 'flex',
    width: '100%',
    minWidth: 0,
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing(8),
    padding: `${spacing(8)} ${spacing(12)}`,
    border: `${spacing(1)} solid ${Theme.Colors.Grayscale.Twelve}`,
    borderRadius: spacing(8),
  },
  paymentLinkItemContent: {
    display: 'flex',
    minWidth: 0,
    flex: 1,
    alignItems: 'center',
    gap: spacing(8),
  },
  paymentLinkUrl: {
    flex: '0 1 auto',
    minWidth: 'auto',
    color: Theme.Colors.Primary.Base,
    textDecoration: 'underline',
    wordBreak: 'break-all',
    overflowWrap: 'anywhere',
  },
  paymentLinkCopyButton: {
    flexShrink: 0,
    padding: spacing(4),
  },
  paymentLinkActions: {
    display: 'flex',
    gap: spacing(12),
    flexWrap: 'wrap',
  },
  manualToggle: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(8),
    margin: 0,
    '& .MuiFormControlLabel-label': {
      fontSize: '1rem',
      color: Theme.Colors.Grayscale.Eighty,
    },
  },
  manualFields: {
    display: 'flex',
    width: '100%',
    gap: spacing(16),
  },
  manualField: {
    flex: 1,
  },
}))
